<template>
  <div class="filter-box">
    <div class="filter-header">
      <div class="filter-type">
        <span>满足下列:</span>
        <RadioGroup v-model="filterType">
          <Radio label="全部条件"></Radio>
          <Radio label="任意条件"></Radio>
        </RadioGroup>
      </div>
      <div class="filter-toggle" :class="{'open': open}" @click.stop="toggleFitler">
        <span class="filter-toggle_ope">{{open ? '收起' : '展开'}}筛选</span><i class="yjh-icon icon-dropdown"></i>
      </div>
    </div>
    <div class="filter-content" v-show="open" ref="filterContent">
      <div class="filter-item" v-for="(item, index) in filterList" :key="item.num">
        <filterSelect ref="fieldFilter" :selectOptions="fields" :Index="index" class="filter-select" @selectData="selectData"></filterSelect>
        <!-- 公式 -->
        <template v-if="Number(item.fieldType) !== 3">
          <Select ref="fieldFilter" v-model="item.aggr" class="filter-sel" style="width: 120px;" placeholder="请选择" @on-change="updateAggr(item, index)">
            <Option v-for="opt in aggrs" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
          </Select>
        </template>
        <template v-else>
          <Select ref="fieldFilter" v-model="item.aggr" class="filter-sel" style="width: 120px;" placeholder="请选择" @on-change="updateAggr(item, index)">
            <Option v-for="opt in timeAggrs" :value="opt.value" :key="opt.value">{{ opt.label }}</Option>
          </Select>
        </template>
        <!-- 取值 -->
        <template v-if="Number(item.fieldType) !== 3">
          <Input v-model="item.value" placeholder="" style="width: 320px" :disabled="item.disabled" @click="openTimeDiag"/>
        </template>
        <template v-else>
          <DatePicker ref="fieldFilter" type="daterange" v-model="item.value" placeholder="" style="width: 320px" :disabled="item.disabled" :editable="false" :clearable="false"></DatePicker>
        </template>
        <!-- 添加删除按钮 -->
        <div class="filter-addon">
          <i class="iconfont iconshanchu" v-if="filterList.length !== 1" @click.stop="delFilter(index)"></i>
          <i class="iconfont icontianjia" @click.stop="addFilter(index)" v-if="index === filterList.length - 1"></i>
        </div>
        <div class="filter-btn yjh-btn" :class="{'disabled': btnDisabled}" v-if="index === filterList.length - 1" @click.stop="confirmFilter">查询</div>
      </div>
    </div>
  </div>
</template>

<script>
import filterSelect from './filterSelect'
import { mapState } from 'vuex'
import { dateObjToStr2 } from '@/utils/common'
import _ from 'underscore'
export default {
  components: { filterSelect },
  props: {
    fields: {
      type: Array,
      require: true
    },
    btnDisabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      filterType: '全部条件',
      open: false,
      filterList: [{
        field: '', // 选项1的值
        fieldType: '', // 选项1的类型
        aggr: '', // 选项2值
        disabled: false, // 自己增加状态标记
        value: '', // 第三个的值
        num: Math.random()
      }]
    }
  },
  computed: {
    ...mapState({
      timeAggrs: state => state.globalConst.timeAggrs,
      aggrs: state => state.globalConst.aggrs
    })
  },
  watch: {
    $route() {
      this.init()
    }
  },
  mounted() {
    const _this = this
    _this.$refs.filterContent.addEventListener('scroll', () => {
      _this.$refs.fieldFilter.map(item => {
        if (item.closeDrop !== undefined) {
          item.closeDrop && item.closeDrop()
        } else {
          item.visible = false
        }
      })
    })
  },
  methods: {
    init() {
      this.open = false
      this.filterType = '全部条件'
      this.filterList = [{
        field: '',
        fieldType: '',
        aggr: '',
        disabled: false,
        value: ''
      }]
    },
    // 切换/显示
    toggleFitler() {
      this.open = !this.open
      this.$emit('toggleFilterShow')
    },
    // 增加一条筛选
    addFilter(Index) {
      const lastFilter = this.filterList[Index]
      if (lastFilter.field === '' || lastFilter.aggr === '' || (!lastFilter.disabled && lastFilter.value === '')) {
        this.$Message.info('请确保所有筛选项不为空')
        return
      }
      if (this.filterList.length >= 20) {
        this.$Message.info('筛选项最多有20条')
        return
      }
      this.filterList.push({
        field: '',
        fieldType: '',
        aggr: '',
        disabled: false,
        value: '',
        num: Math.random()
      })
      this.$nextTick(() => {
        this.$refs.filterContent.scrollTop = 1000
      })
      this.$emit('toggleFilterShow')
    },
    // 删除一条筛选
    delFilter(i) {
      this.filterList.splice(i, 1)
      this.$emit('toggleFilterShow')
    },
    selectData(data) {
      const item = data.params
      const index = data.index
      this.$set(this.filterList[index], 'field', item.value)
      this.$set(this.filterList[index], 'fieldType', item.type)
      if (Number(data.params.type) === 3) {
        this.$set(this.filterList[index], 'aggr', '70')
        const date = dateObjToStr2(new Date())
        this.$set(this.filterList[index], 'value', [date, date])
      } else {
        this.$set(this.filterList[index], 'aggr', '10')
        this.$set(this.filterList[index], 'value', '')
      }
      // 校验
      if (this.filterType === '全部条件' && this.filterList.length) {
        for (var i = 0; i < this.filterList.length; i++) {
          if (i !== index && (this.filterList[i].field === item.value)) {
            this.$Message.info('筛选条件重复')
            return
          }
        }
      }
    },
    // 选择字段 并改变fieldType的值
    updateField(item, index) {
      this.$set(this.filterList[index], 'field', item.value)
      this.$set(this.filterList[index], 'fieldType', item.type)
      this.$set(this.filterList[index], 'aggr', '')
      this.$set(this.filterList[index], 'value', '')
      // 校验
      if (this.filterType === '全部条件' && this.filterList.length) {
        for (var i = 0; i < this.filterList.length; i++) {
          if (i !== index && (this.filterList[i].field === item.value)) {
            this.$Message.info('筛选条件重复')
            return
          }
        }
      }
    },
    // 选择公式
    updateAggr(item, index) {
      if (Number(item.type) === 3) { // 先分开处理 后面可能不需要分开处理
        if (item.aggr === '50' || item.aggr === '60') {
          this.$set(this.filterList[index], 'disabled', true)
        } else {
          this.$set(this.filterList[index], 'disabled', false)
        }
      } else {
        if (item.aggr === '50' || item.aggr === '60') {
          this.$set(this.filterList[index], 'disabled', true)
        } else {
          this.$set(this.filterList[index], 'disabled', false)
        }
      }
    },
    // 打开时间弹框
    openTimeDiag() {
    },
    // 查询
    confirmFilter() {
      if (this.btnDisabled) {
        return
      }
      if (this.filterType === '全部条件') { // 全部条件才需要判断重复
        if (!this.checkChongFu()) {
          this.$Message.info('筛选条件重复')
          return
        }
      }
      if (!this.checkNoEmpty()) {
        this.$Message.info('请确保所有筛选项不为空')
        return
      }
      this.emit()
    },
    checkChongFu() {
      const obj = {}
      for (var i = 0; i < this.filterList.length; i++) {
        if (this.filterList[i].field in obj) {
          return false
        } else {
          obj[this.filterList[i].field] = '已经存在'
        }
      }
      return true
    },
    checkNoEmpty() {
      for (var i = 0; i < this.filterList.length; i++) {
        if (this.filterList[i].field === '' || this.filterList[i].field === undefined) {
          return false
        }
        if (this.filterList[i].aggr === '' || this.filterList[i].aggr === undefined) {
          return false
        }
        if (!this.filterList[i].disabled) {
          if (Number(this.filterList[i].fieldType) === 3) {
            if (this.filterList[i].value[0] === '' || this.filterList[i].value[1] === '') {
              return false
            }
          } else {
            if (this.filterList[i].value === '') {
              return false
            }
          }
        }
      }
      return true
    },
    emit: _.debounce(function() {
      const filter = this.filterList.map(obj => {
        const list = {}
        list.field_name = obj.field
        list.aggregator = obj.aggr
        list.field_type = obj.fieldType
        if (!obj.disabled && Number(obj.fieldType) === 3) {
          list.value = []
          list.value[0] = dateObjToStr2(obj.value[0])
          list.value[1] = dateObjToStr2(obj.value[1])
        } else {
          list.value = [obj.value]
        }
        return list
      })
      const params = {
        filter_type: this.filterType === '全部条件' ? '1' : '2',
        filter
      }
      this.$emit('filterConSearch', params)
    }, 500, true),
    searcInput: _.debounce(function(value, index) {
      const arr = this.fields.filter(item => {
        return item.display.indexOf(value) !== -1
      })
      this.filterList[index].options = arr
    }, 500, false)
  }
}
</script>

<style lang="scss" scoped>
  .filter-box {
    position: relative;
    border: 1px solid #E9EEF6;
    background: #F8F9FA;
    padding: 20px 20px 0 20px;
  }
  .filter-type {
    padding-bottom: 20px;
    line-height: 16px;
    & > span {
      margin-right: 10px;
    }
  }
  .filter-toggle {
    cursor: pointer;
    position: absolute;
    right: 24px;
    top: 23px;
  }
  .filter-content {
    max-height: 176px;
    padding-bottom: 20px;
    overflow: auto;
  }
  .filter-item + .filter-item {
    margin-top: 20px;
  }
  .filter-sel {
    margin-right: 20px;
  }
  .filter-addon {
    display: inline-block;
    width: 76px;
    height: 28px;
    line-height: 28px;
    padding-left: 20px;
    margin-right: 40px;
    i + i {
      margin-left: 20px;
    }
  }
  .disabled {
    cursor: not-allowed;
    opacity: .3;
    &:hover {
      opacity: .3;
    }
  }
  .filter-select {
    width: 210px;
    margin-right: 20px;
  }
</style>
<style lang="scss">
.filter-box {
  .ivu-select.filter-select { // 封装的reSelect的样式
    .ivu-select-dropdown {
      width: 210px;
      padding-top: 0px;
      overflow: inherit;
      max-height: 250px;
      .yjh_select__search {
        position: relative;
        padding: 4px 0px;
        > input {
          width: calc( 100% - 24px);
          margin-left: 10px;
          padding: 4px 0px;
          border: none;
          border-bottom: 1px solid #1881DC;
        }
        > i {
          position: absolute;
          right: 10px;
          top: 8px;
        }
      }
      .yjh-scroll {
        margin-top: 4px;
        overflow-x: hidden;
        overflow-y: auto;
        max-height: 200px;
      }
      .ivu-select-item {
        font-size: 19px;
        color: #5D6F80;
        font-weight:400;
        // font-family:PingFangSC-Regular;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
